import React, {MutableRefObject} from 'react';
import {Dimensions} from 'react-native';
import {SwipeableMethods} from 'react-native-gesture-handler/ReanimatedSwipeable';
import {maxSwipeDistance} from 'src/components/elements/RenderRightDelectActions';

export function useDeleteSwipe({
  onPress,
}: {
  onPress: () => void | Promise<void>;
}): [
  number,
  number,
  MutableRefObject<SwipeableMethods>,
  () => void,
  () => void,
  () => void,
] {
  const [isSwiping, setIsSwiping] = React.useState(false);
  const screenWidth = Dimensions.get('window').width;
  const swipeableRef = React.useRef<SwipeableMethods>(null);
  const handleSwipeStart = () => {
    setIsSwiping(true);
  };
  const handleSwipeEnd = () => {
    setIsSwiping(false);
  };

  const handlePress = () => {
    if (isSwiping) {
      return;
    }
    onPress();
  };
  return [
    maxSwipeDistance,
    screenWidth,
    swipeableRef,
    handleSwipeStart,
    handleSwipeEnd,
    handlePress,
  ];
}
